// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bha_a bhp_h","Menu__offsetParent":"bha_b bhp_bj","Menu__trigger--shadowed":"bha_c"};